import { createApp } from 'vue';
import App from './App.vue';
import { vDeal } from './ui/motion/deal';
import './style.css';
import './ui/kit/kit.css';
// Shared chrome for the admin panel's panes. Every selector is namespaced
// under `.admin-main`, which only the panel renders.
import './admin/pane.css';
// Side-effect import: registers the <altcha-widget> custom element exactly
// once. `customElements.define()` throws on a second registration of the same
// tag, and under Vite's dev-time module graph two importers can each resolve
// their own copy of a side-effect import — so it is registered here and
// nowhere else.
import 'altcha';

/**
 * <altcha-widget>'s default English copy calls the checked state "Verified".
 * There is no per-instance string override, only the global i18n store the
 * package populates for `"en"` on import — so the override reads that default
 * back and patches the one key, or every other string would be lost.
 */
interface AltchaI18nStore {
  get: (key: string) => Record<string, string> | undefined;
  set: (key: string, value: Record<string, string>) => void;
}
const altchaGlobal = (window as unknown as { $altcha?: { i18n: AltchaI18nStore } }).$altcha;
if (altchaGlobal) {
  const en = altchaGlobal.i18n.get('en') ?? {};
  altchaGlobal.i18n.set('en', { ...en, verified: 'Security check passed' });
}

createApp(App).directive('deal', vDeal).mount('#app');
